const EnvNames = {
  Development: "development",
  Test: "test",
  Staging: "staging",
  Production: "production",
};

const SystemType = {
  Jiemo: "jiemo",
  RSS: "rss",
  VSS: "vss",
  LPS: "lps",
};

export { EnvNames, SystemType };
